import React from 'react';
import { Grid, Typography, Stack, Divider, Box, Radio, RadioGroup, IconButton, Backdrop, CircularProgress, Button } from '@mui/material';
import { CustomButton, InputProps, StyledBlueCard, StyledCard, StyledCardTitle, StyledBlueCardTitle, CustomTextField, CustomRadioWhite } from 'custom/componentsnew';
import moment from 'moment';
import { AddIcon, ClearXIcon, DateFormat, DeleteIcon, EditIcon, SaveTickIcon } from 'custom/constants';
import docStyles from './anydoc.module.css';
import styles from '../../../custom/style.module.css';
import { Undo } from '@mui/icons-material';

const ProfileWithDocView = (props) => {
  console.log(props, 'props');
  const docPages = Array.isArray(props.editedDocScanned?.pages) ? [...props.editedDocScanned.pages] : [];

  const firstPage = docPages?.[0];
  return (
    <div>
      <Backdrop
        sx={(theme) => ({
          color: '#fff',
          zIndex: theme.zIndex.drawer + 1 
        })}
        open={props.loadingDoc}
      >
        <CircularProgress color='inherit' />
      </Backdrop>
      <Grid container spacing={3} sx={{ height: '100%' }}>
        {/* Left: Profile Info */}
        <Grid item xs={12} lg='auto'>
          <StyledBlueCard elevation={0} className={styles.h100} sx={{
            minWidth: { md: 310 },
            maxWidth: { md: 310 }
          }}>
            <Box sx={{ width: '100%' }}>
              <Stack direction='row' alignItems='center' justifyContent='space-between' sx={{ mb: 2 }}>
                <StyledBlueCardTitle>Document Recognized</StyledBlueCardTitle>
                <AddIcon className={`${styles.addIcon} ${styles.whiteSvg}`} title='Add Document' onClick={() => props.handleOpen('addDoc')} />
              </Stack>
              <Box component='div' className={docStyles.viewDocList}>
                <RadioGroup
                  name='document-radio-group'
                  value={props.selectedDoc}
                  onChange={(e) => props.handleDocSelectionChange(e.target.value)}
                >
                  <CustomRadioWhite
                    key={'none'}
                    value={'none'}
                    control={<Radio size='small' />}
                    
                    label={
                      <Box className={docStyles.viewDocItem}>None</Box>
                    }
                  />
                  <Divider sx={{
                    my: 1,
                    borderColor: '#ffffff58' 
                  }} />
                  {props.docPrompts.map((doc) => (
                    <>
                      <Stack direction='row' alignItems='center' justifyContent='space-between'>
                        <CustomRadioWhite
                          key={doc.id}
                          value={doc.id}
                          control={<Radio size='small' />}
                    
                          label={
                            <Box className={docStyles.viewDocItem}>
                              {doc.document_type} | {moment(doc.created_at).format(DateFormat).toUpperCase()}
                              <Typography variant='caption' component='p' sx={{
                                color: 'primary.contrastSecondaryText',
                                fontWeight: 600,
                              }}>
                                {doc.description || 'No description available.'}
                              </Typography>
                            </Box>
                          }
                          color='secondary'
                        />
                        <DeleteIcon onClick={(e) => props.handleDeleteDocPrompt(doc.id, e.target)} className={`${styles.whiteSvg} ${docStyles.delIcon}`} />
                      </Stack>
                      <Divider sx={{
                        my: 1,
                        borderColor: '#ffffff58' 
                      }} />
                    </>
                  ))}
                </RadioGroup>
              </Box>
            </Box>
          </StyledBlueCard>
        </Grid>
        {/* Left: Profile Info */}
        <Grid item xs={12} md={12} lg>
          <StyledCard  sx={{
            height: '100%',
            minHeight: 480,
          }}>
            {/* Document not uploaded */}
            {docPages.length === 0 && (
              <Stack direction='column' alignItems='center' justifyContent='center' sx={{ height: '100%' }} spacing={2}>
                <Typography variant='h5' color='primary'>No document data available.</Typography>
                <Typography variant='body2' color='text.secondary'>Please select a document type from the list before uploading a document.</Typography>
                <Button variant='outlined' onClick={() => props.handleOpen('addDoc')}>Add Document</Button>
              </Stack>
            )}
            {/* Document uploaded */}
            {
              docPages.length > 0 && (
                <Box component='div'>
                  <Stack direction='row' alignItems='center' justifyContent='space-between' sx={{ mb: 2 }}>
                    <div>
                      <StyledCardTitle>{firstPage?.document_type}</StyledCardTitle>
                      <Typography variant='caption' color='text.secondary' align='left' sx={{ mb: 2 }} />

                    </div>
                    <Button variant='outlined' onClick={() => props.handleOpen('addDoc')}>Add Document</Button>
                  </Stack>

                  <Divider sx={{
                    width: '100%',
                    my: 2 
                  }} />
                  <Box sx={{ width: '100%' }}>
                    <Stack spacing={1}>
                      <Box component='div'>
                        <Box component='div' sx={{
                          height: 380,
                          overflowY: 'auto',
                          pr: 3,
                          marginRight: -3,
                          pb: 1 
                        }}>
                          {docPages?.map((page, pageIndex) => {
                            return (page?.data?.extracted_fields || []).map((data, i) => {
                              const isMarked = Object.keys(props.removedFields || {}).includes(data?.label);
                              return (
                                <Stack key={`${pageIndex}-${i}`}
                                  direction='row'
                                  spacing={2}
                                  justifyContent='space-between'
                                  className={docStyles.docDataItem}
                                  mb={1} 
                                >
                                  <Stack direction='row' spacing={1} alignItems='center' sx={{
                                    color: isMarked ? 'text.secondary':'text.primary',
                                    textDecoration: isMarked ? 'line-through' : 'none'
                                  }}>
                                    <Typography  variant='body2' color='inherit' minWidth='200px' maxWidth='200px'>{data.label}</Typography>
                                    <Typography  variant='body2' color='inherit'>:</Typography>
                        
                                    {props.isEditable === `${pageIndex}-${i}` ? <CustomTextField
                                      {...InputProps}
                                      fullWidth
                                      id=''
                                      name={data.label}
                                      placeholder='Add notes'
                                      type='text'
                                      onChange={(e) => props.onChangeValue(e, pageIndex, i)}
                                      value={props.editedFields?.[data.label] || data.value}
                                      className={`${styles.borderedIpTextfield}`}
                                      InputProps={{
                                        classes: {
                                          root: styles.borderedIpRoot,
                                          input: styles.borderedIp,
                                          notchedOutline: styles.notchedOutline,
                                          error: styles.errorInput,
                                        },
                                      }}
                                    /> :
                                      <Typography  variant='body2' color='inherit'>{data.value}</Typography>
                                    }
                                  </Stack>
                                  {!props.isIterated && (
                                    <Stack spacing={1} direction='row' alignItems='flex-start' className={styles.actionIcons}>
                                      {isMarked && <Typography variant='caption' color='error.main' ml='auto'>Marked for deletion</Typography>}
                                      {isMarked ?
                                        <IconButton onClick={() => props.revertMarked(data, pageIndex, i)}><Undo /></IconButton>:
                                        <ClearXIcon onClick={() => props.handleClearField(data.label, data.value)} className={docStyles.clearIcon} />
                                      }
                                      { !isMarked &&
                                      (props.isEditable === `${pageIndex}-${i}` ?
                                        <IconButton className={docStyles.tickIcon} onClick={() => props.handleSaveValue(data.label, data.value, pageIndex, i)} >
                                          <SaveTickIcon />
                                        </IconButton>
                                        :
                                        <EditIcon onClick={() => props.handleEditField(data, pageIndex, i)} className={docStyles.editIcon} />)
                                      }
                                    </Stack>
                                  )}
                                </Stack>
                              );
                            });
                          })}
                        </Box>
                      </Box>

                      {/* Manual Input */}
                      {Object.keys(props.addedFields || {}).length > 0 && (
                        <Typography variant='body2' color='text.secondary'>---Manual Entries---</Typography>
                      )}
                      {Object.entries(props.addedFields || {})?.map(([key, field], index) => (
                        <Stack key={`manual-${index}`}
                          direction='row'
                          spacing={2}
                          justifyContent='space-between'
                          className={docStyles.docDataItem} 
                        >
                          <Stack direction='row' spacing={1} alignItems='center' color='text.primary'>
                            <Typography variant='body2' color='inherit' minWidth='200px' maxWidth='200px'>{key}</Typography>
                            <Typography variant='body2' color='inherit'>:</Typography>
                            <Typography variant='body2' color='inherit'>{field}</Typography>
                          </Stack>
                          {!props.isIterated && (
                            <Box component='span' className={styles.actionIcons}>
                              <ClearXIcon onClick={() => props.handleRemoveField(key)} className={docStyles.clearIcon} />
                            </Box>
                          )}
                        </Stack>
                      ))}

                      {docPages.length > 0 &&
                    <>
                      <CustomTextField
                        {...InputProps}
                        fullWidth
                        multiline
                        id=''
                        name='docNotes'
                        placeholder='Add notes'
                        type='text'
                        onChange={(e) => props.onChangeTextField(e)}
                        value={props.docNotes}
                        rows={2}
                        maxRows={3}
                        className={`${styles.borderedIpTextfield}`}
                        disabled={props.isIterated}
                        InputProps={{
                          classes: {
                            root: styles.borderedIpRoot,
                            input: styles.borderedIp,
                            notchedOutline: styles.notchedOutline,
                            error: styles.errorInput,
                          },
                        }}
                      />
                      {!props.isIterated ? 
                        <Stack direction='row' justifyContent='space-between' spacing={2}>
                          <CustomButton variant='contained' onClick={() => props.handleOpen('manual_input')}>Add New Field</CustomButton>
                          <CustomButton variant='contained' onClick={props.onSave}>Submit</CustomButton>
                        </Stack> 
                        : 
                        <Stack direction='row' justifyContent='space-between' spacing={2}>
                          <CustomButton variant='contained' onClick={() => props.handleOpen('reject_extraction')}>Reject</CustomButton>
                          <CustomButton variant='contained' onClick={() => props.handleOpen('approve_extraction')}>Accept</CustomButton>
                        </Stack>
                      }
                    </>       
                      }
                    </Stack>
                  </Box>
                </Box>)}
          </StyledCard>
        </Grid>
        <Grid item xs={12} lg='auto'>
          <StyledCard className={styles.h100} sx={{
            minWidth: { md: 310 },
            maxWidth: { md: 310 }
          }}>
            <Box sx={{ width: '100%' }}>
              <Stack direction='row' alignItems='center' justifyContent='space-between' sx={{ mb: 2 }}>
                <StyledCardTitle>Define Actions</StyledCardTitle>
                <AddIcon className={`${styles.addIcon}`} title='Add Document' />

              </Stack>
              <Box component='form'>
                <Stack spacing={2}>
                  <CustomTextField
                    {...InputProps}
                    fullWidth
                    id='actionName'
                    name='actionName'
                    label='Name of Action'
                    placeholder='Enter action name'
                    type='text'
                  />
                  <CustomTextField
                    {...InputProps}
                    fullWidth
                    id='actionValue'
                    name='actionValue'
                    label='Instructions for Action'
                    placeholder='Enter action value'
                    type='text'
                    minRows={3}
                    maxRows={5}
                    multiline
                  />
                  <CustomTextField
                    {...InputProps}
                    fullWidth
                    id='actionRules'
                    name='actionRules'
                    label='Rules for Action'
                    placeholder='Enter action rules'
                    type='text'
                    minRows={3}
                    maxRows={5}
                    multiline
                  />
                  <CustomButton variant='contained' disabled onClick={props.onAddAction}>Add Action</CustomButton>
                </Stack>
              </Box>
            </Box>
          </StyledCard>
        </Grid>
      </Grid>
    </div>
  );
};

export default ProfileWithDocView;
